export function Footer() {
  return (
    <footer className="app-footer">
      <p>© 2026 Neelkamal Mallick. All rights reserved.</p>
      <p>
        Contact: <a href="mailto:neelkamalmallick@gmail.com">neelkamalmallick@gmail.com</a>
      </p>
    </footer>
  );
}
